module.exports = __webpack_public_path__ + "components/country-flag/static/mt-1b892c29c9b47f60e81538f9af8bdf2d.svg";